import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface BannerButton {
  label: string;
  onClick(): void;
}

@Component({
  selector: 'ar-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @Input() type: 'primary' | 'success' | 'warning' | 'danger' = 'primary';
  @Input() title: string;
  @Input() inline = false;
  @Input() icon: string;
  @Input() cancelButton: BannerButton;
  @Input() submitButton: BannerButton;
  @Output() dismiss = new EventEmitter();

  icons = {
    primary: 'info',
    success: 'check_circle',
    warning: 'warning',
    danger: 'warning'
  };

  ngOnInit(): void {
    this.inline = this.inline || !this.title;
  }
}
